module.exports = __webpack_public_path__ + "img/01.21bcc44a.png";